<template>
  <div :style="`animation-delay: -${this.value}s; width: ${size};height: ${size}`"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '36px',
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      baseFontSize: 1,
      bgColor: '#00cc00',
    }
  },
  computed: {
    cssProps() {
      return {
        '--chart-size': this.baseFontSize * 2 + 'em',
        '--bg-chart-color': this.bgHoverColor,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$c1: var(--light-color); // chart color
$c2: var(--info-color); // active color

div {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  position: relative;
  background: $c1 linear-gradient(to right, $c1 50%, $c2 50%);
  color: $c2;
  border-radius: 50%;

  @keyframes spin {
    to {
      transform: rotate(180deg);
    }
  }

  @keyframes background {
    50% {
      background-color: currentColor;
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 80%;
    height: 80%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background: var(--body-color);
    border-radius: 50%;
  }
  &::before {
    content: '';
    position: absolute;
    display: block;
    background-color: inherit;
    height: 100%;
    width: 50%;
    bottom: 0;
    right: 0;
    border-radius: 0 100% 100% 0 / 50%;
    transform: rotate(0);
    transform-origin: 0 50%;
    animation: 50s spin infinite linear, 100s background infinite step-end;
    animation-play-state: paused;
    animation-delay: inherit;
  }
}
</style>